import { render, staticRenderFns } from "./Service-single.vue?vue&type=template&id=4b95f377&scoped=true"
import script from "./Service-single.vue?vue&type=script&lang=js"
export * from "./Service-single.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b95f377",
  null
  
)

export default component.exports